
export const isReady =(self: any, id: string) => {
  const index = self.states.findIndex(p => p.id === id);
  if (index === -1) {
    return true;
  } else {
    return self.states[index].state !== 'pending';
  }
};

export const hasError =(self: any, id: string) => {
  const index = self.states.findIndex(p => p.id === id);
  if (index === -1) {
    return false;
  } else {
    return self.states[index].state === 'error';
  }
};

